import { render, staticRenderFns } from "./NativeSorting.vue?vue&type=template&id=c196455e&lang=pug&"
import script from "./NativeSorting.vue?vue&type=script&lang=js&"
export * from "./NativeSorting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports